/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { UNLICENSED } from '@jira/platform__application-editions/src/edition.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useShowCustomers = (): boolean => {
	const { hasCustomerServiceAccess } = useApplicationPermissions();
	const { customerService } = useAppEditions();

	if (customerService === UNLICENSED) {
		return false;
	}

	return hasCustomerServiceAccess;
};
